module.exports = __webpack_public_path__ + "static/media/pages.1f32d94e.svg";